import { computed, Directive, input, output, TemplateRef } from '@angular/core';
import { IProductTypeOverview } from '@cakeiteasy/web-utils';

import { parseCakeBuilderUrl } from './cake-builder-link';

/** Card parts the cake-item container renders once; every card variant places them in its own grid. */
export interface ICakeItemBlocks {
  media: TemplateRef<unknown>;
  badges: TemplateRef<unknown>;
  cartCount: TemplateRef<unknown>;
  /** mobile "Buy" of the media itself (complex / pieces group without anything in the cart) */
  buy: TemplateRef<unknown>;
  footer: TemplateRef<unknown>;
}

/**
 * Base of the card variants (cake-item-pieces, -pieces-group, -complex, -catering, -request).
 * A variant is a flat grid: the media, the hover overlay parts and the footer parts are all direct children of
 * .ws-product-card (layout in styles/themable/_product-card.scss). Cart logic stays in the cake-item container;
 * a variant only lays out and reports actions.
 */
@Directive()
export abstract class CakeItemVariant {
  cake = input.required<IProductTypeOverview>();
  productTypeBuilderUrl = input<string>();
  blocks = input.required<ICakeItemBlocks>();
  cardClasses = input<{ [klass: string]: boolean }>({});

  /** any click on the media area; the container decides what it means */
  mediaClick = output<void>();

  builderLink = computed(() => parseCakeBuilderUrl(this.productTypeBuilderUrl()));

  /** clicks inside the media area bubble here after the part's own handler, as they did through the old overlay */
  onCardClick(event: MouseEvent) {
    if ((event.target as HTMLElement).closest('.ws-product-card__media-part')) {
      this.mediaClick.emit();
    }
  }
}
